import { css } from "styled-components";

import { PRIMARY_200, PRIMARY_600 } from "../../constant/colors";

// TMCore focus ring for BUTTONS. Fields use a different pair on purpose (Primary 400 + 2px
// Primary 100, design system 1078:20941) — don't unify them.
export const focusRing = css`
  border-color: ${PRIMARY_600} !important;
  box-shadow: 0 0 0 4px ${PRIMARY_200} !important;
`;
